import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import pickBy from 'lodash/pickBy';

import {revertLocationParamsConvertion} from 'app/store/sweet-api/utils';

import type {
  NotificationsFetchParamsType,
  NotificationsLocationParamsType,
} from './types';
import type {DefaultRootState} from 'react-redux';

const initialState = {
  filters: {} as NotificationsLocationParamsType,
  browserNotificationPermStatus: window.Notification?.permission || 'denied',
  hideNotificationPermBanner: false,
};

export const notiflySlice = createSlice({
  name: 'notifly',
  initialState,
  reducers: {
    setNotificationFilters(
      state,
      action: PayloadAction<NotificationsFetchParamsType>
    ) {
      state.filters = revertLocationParamsConvertion(action.payload);
    },
    setBrowserNotificationPermStatus(
      state,
      action: PayloadAction<NotificationPermission>
    ) {
      state.browserNotificationPermStatus = action.payload;
    },
    setHideNotificationPermBanner(state, action: PayloadAction<boolean>) {
      state.hideNotificationPermBanner = action.payload;
    },
  },
});

export const {
  setNotificationFilters,
  setBrowserNotificationPermStatus,
  setHideNotificationPermBanner,
} = notiflySlice.actions;

export function selectPermanentlyHideBrowserNotificationBanner(
  state: DefaultRootState
) {
  // We permanently hide the notification banner if the user interacted with it
  // in some way positive or negative.
  return state.notifly.browserNotificationPermStatus != 'default';
}
export const selectHideNotificationPermBanner = (state: DefaultRootState) =>
  state.notifly.hideNotificationPermBanner;
export const selectNotiflyFilters = (
  state: DefaultRootState
): NotificationsLocationParamsType => pickBy(state.notifly.filters);
